import { openModal } from 'Helpers/ModalHelper';
import { buildModalQuery } from 'Consts/ModalQueries';
import modalConsts from 'Consts/ModalNames';
import fr from 'facet-rest';
import relationships from 'facet-rest/src/consts/relationships';
import listActionItemMenuItems
  from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/ListActionItemMenuItems/ListActionItemMenuItems';

const useListItemActionsMenu = (
  resource,
  args,
  onClose,
) => {
  const {
    completed,
    toggleHide,
    markAsComplete,
    hidden,
    actionItemOnClick,
    handleQuestionOnClick,
  } = args;
  // Task conditions
  const userCanUpdateActionItem = resource.attr('isReadOnly') !== 'true';
  const isAccountFundingAi = resource.attr('actionItemType') === 'fund-account';
  const isAccountAi = Boolean(resource.relationship(relationships.accountOpeningWizard.name)?.link('related'));
  const isAccountRetitlingAi = Boolean(resource.relationship(relationships.accountRetitlingWizard.name)?.link('related'));
  const trustApprovalRelationship = resource.relationship(fr.relationships.approval.name)?.link('related');
  const isTrustApproval = Boolean(trustApprovalRelationship);

  const displayFileUploader = !isAccountFundingAi && !isAccountAi && !isAccountRetitlingAi && !isTrustApproval;

  // Edit task
  const handleEditTask = () => {
    openModal(
      buildModalQuery(modalConsts.clientActionItemModal, {
        actionItemId: resource.id(),
      }),
    );
  };

  const taskActions = listActionItemMenuItems(
    resource,
    hidden,
    toggleHide,
    completed,
    userCanUpdateActionItem,
    handleEditTask,
    isAccountAi,
    isAccountFundingAi,
    isAccountRetitlingAi,
    markAsComplete,
    actionItemOnClick,
    handleQuestionOnClick,
    onClose,
  );

  return {
    taskActions,
    displayFileUploader,
  };
};

export default useListItemActionsMenu;
